/**
 * Uma faixa 100% empilhada — «como o todo se reparte», numa linha.
 *
 * É o desenho certo para a concentração de uma carteira: catorze cedentes com 7% cada e dois
 * grupos com 44% cada ocupam a mesma largura total, e a diferença entre os dois quadros salta.
 *
 * A legenda vai por baixo com os números, e não dentro da faixa: um pedaço de 2% não comporta
 * texto, e escondê-lo num tooltip seria o mesmo que não o ter.
 */
import { COR_NEUTRA, corDaSerie, pct } from './escalas';

export type Fatia = { rotulo: string; valor: number; neutro?: boolean };

export function FaixaParticipacao({
  fatias,
  vazio = 'Sem dados.',
}: {
  fatias: Fatia[];
  vazio?: string;
}) {
  const total = fatias.reduce((s, f) => s + f.valor, 0);
  if (!fatias.length || total <= 0)
    return <p className="tipo-corpo-pequeno text-text-tertiary">{vazio}</p>;

  return (
    <div className="flex flex-col gap-2">
      <div className="flex h-2.5 w-full overflow-hidden rounded-full bg-surface-3">
        {fatias.map((f, i) => (
          <div
            key={`${f.rotulo}-${i}`}
            style={{
              width: `${(f.valor / total) * 100}%`,
              background: f.neutro ? COR_NEUTRA : corDaSerie(i),
            }}
            // O title cobre o hover, mas o número TAMBÉM está na legenda abaixo — o title é
            // conveniência, nunca o único lugar onde o dado existe.
            title={`${f.rotulo}: ${pct((f.valor / total) * 100)}`}
          />
        ))}
      </div>
      <ul className="flex flex-wrap gap-x-4 gap-y-1">
        {fatias.map((f, i) => (
          <li
            key={`${f.rotulo}-${i}`}
            className="tipo-corpo-pequeno flex items-center gap-1.5 text-text-secondary"
          >
            <span
              className="size-2.5 shrink-0 rounded-full"
              style={{ background: f.neutro ? COR_NEUTRA : corDaSerie(i) }}
            />
            <span className="truncate">{f.rotulo}</span>
            <span className="tipo-dado text-text">{pct((f.valor / total) * 100)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
